import styled from 'styled-components'

export const Container = styled.div`
  .mobile {
    margin-top: 21px;
    padding: 0 1.5rem;
  }

  @media only screen and (min-width: 1090px) {
    .mobile {
      display: none;
    }
  }
`

export const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  height: 62px;
  border: 1px solid #bababa;
  border-left: none;
  border-right: none;
  margin-left: -1.5rem;
  margin-bottom: 23px;
  margin-top: 23px;
  padding-right: 1.5rem;
  padding-left: 1.5rem;

  @media only screen and (min-width: 1090px) {
    width: 100%;
    border: 1px solid #bababa;
    border-radius: 8px;
    margin-left: 0px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const GenerateNotebook = styled.div`
  display: none;
  color: #909090;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;

  @media only screen and (min-width: 1090px) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    &:hover {
      color: #ff6600;
      cursor: pointer;
    }
  }
`

export const GenerateNotebookFullScreen = styled.div`
  display: none;
  color: #909090;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;

  @media only screen and (min-width: 1090px) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 4rem;
    width: 17%;
    gap: 6px;

    .expand {
      color: #ff6600;
      cursor: pointer;
    }
    &:hover {
      color: #ff6600;
      cursor: pointer;
    }
  }
`

export const Summary = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  color: #909090;
  gap: 6px;
  padding-left: 1.5rem;

  border: none;
  background: none;

  @media only screen and (min-width: 1090px) {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    color: #909090;
    gap: 6px;

    &:hover {
      color: #ff6600;
      cursor: pointer;
    }
  }
`

export const PaginateWrapper = styled.div`
  display: none;

  @media only screen and (min-width: 1090px) {
    display: flex;
  }
`

export const LettersUpDown = styled.div`
  display: grid;
  grid-template-columns: 50px 50px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border: 1px solid #bababa;
  border-radius: 3px;
  background: transparent;
  margin-right: -1.3rem;

  @media only screen and (min-width: 1090px) {
    display: grid;
    grid-template-columns: 50px 50px;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    border: 1px solid #bababa;
    border-radius: 3px;
    background: transparent;
    margin-right: 1rem;
  }
`

export const LetterUp = styled.button`
  text-align: center;
  padding-left: 5px;
  font-size: 14px;
  width: 100%;
  height: 35px;
  color: #808080;
  background: transparent;
  border: none;
  border-right: 1px solid #bababa;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      filter: brightness(0.9);
    }
  }

  @media only screen and (min-width: 1090px) {
    width: 100%;
  }
`

export const LetterDown = styled.button`
  padding-right: 1px;
  width: 90%;
  height: 35px;
  border: none;
  background: transparent;
  color: #808080;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      filter: brightness(0.9);
    }
  }
`

export const Selects = styled.div`
  display: none;

  @media only screen and (min-width: 1090px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;

    .text-dropdown {
      .text-dropdown--button-area {
        padding: 10px;
      }
    }
  }
`

export const PrintQuestionBook = styled.div`
  margin: 0px 0px;
  padding-left: 2.5rem;
  cursor: pointer;

  @media only screen and (min-width: 1090px) {
    margin: 0px 1.5rem;
    padding-left: 0rem;
  }
`

export const Settings = styled.div`
  margin: 0px 0px;
  cursor: pointer;

  @media only screen and (min-width: 1090px) {
    margin: 0px 1rem;
  }
`

export const KeyBoard = styled.div`
  display: none;

  @media only screen and (min-width: 1090px) {
    display: flex;
    cursor: pointer;
    padding-right: 1rem;
    padding-top: 5px;
  }
`

export const PaginationContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  display: flex;
  gap: 12px;

  button {
    border: none;
    background-color: transparent;

    border-radius: 2px;

    padding: 2px 5px;
    font-size: 14px;
    font-weight: 700;

    color: #808080;

    transition: none;

    &[data-active='true'] {
      color: rgb(249, 249, 249);
      background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .page-button {
      background-color: green;
    }
  }
`
